import { useContext, useState, useRef, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { SiteContext } from "../context/SiteContext";
import { Search, Menu, X } from "lucide-react";
import "./Header.css";

// Rotas atualizadas para o padrão limpo com /area/:areaSlug
const searchData = [
  { title: "Portal da Transparência", path: "/area/transparencia" },
  { title: "Governança Corporativa", path: "/area/governanca" },
  { title: "Educação Previdenciária", path: "/area/educacaoPrevidenciaria" },
  { title: "Controles Internos", path: "/area/controlesInternos" },
  { title: "Institucional", path: "/area/institucional" },
  { title: "Notícias", path: "/noticias" }
];

export default function Header() {
  const { config } = useContext(SiteContext);
  const searchRef = useRef(null);

  const [openSearch, setOpenSearch] = useState(false);
  const [query, setQuery] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const filteredResults = searchData.filter((item) =>
    item.title.toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    function handleClickOutside(event) {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setOpenSearch(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
    setOpenSearch(false);
    setQuery("");
  };

  if (!config) return null;

  return (
    <header className="header-wrapper">
      <div className="main-header container">
        {/* Área da Logo com Fundo Diagonal */}
        <div className="logo-section">
          <div className="logo-diagonal-bg"></div>
          <Link to="/" className="logo-container" onClick={handleNavClick}>
            <img src={config.logo} alt="Logo" className="logo-img" />
          </Link>
        </div>

        {/* Container que agrupa Menu e Ações */}
        <div className="nav-actions-container">
          {/* Menu de Navegação */}
          <nav className={`nav-links ${isMobileMenuOpen ? "mobile-open" : ""}`}>
            <NavLink to="/" end onClick={handleNavClick}>
              INÍCIO
            </NavLink>
            <NavLink to="/area/institucional" onClick={handleNavClick}>
              INSTITUCIONAL
            </NavLink>
            <NavLink to="/area/governanca" onClick={handleNavClick}>
              GOVERNANÇA CORPORATIVA
            </NavLink>
            <NavLink to="/area/transparencia" onClick={handleNavClick}>
              TRANSPARÊNCIA
            </NavLink>
            <NavLink to="/area/controlesInternos" onClick={handleNavClick}>
              CONTROLES INTERNOS
            </NavLink>
            <NavLink to="/area/educacaoPrevidenciaria" onClick={handleNavClick}>
              EDUCAÇÃO PREVIDENCIÁRIA
            </NavLink>
            <NavLink to="/noticias" onClick={handleNavClick}>
              NOTÍCIAS
            </NavLink>
          </nav>

          {/* Área de Busca */}
          <div className="search-wrapper" ref={searchRef}>
            <Search
              size={24}
              className="search-icon"
              onClick={() => {
                setOpenSearch((prev) => !prev);
                setIsMobileMenuOpen(false);
              }}
            />

            <div className={`search-expand ${openSearch ? "open" : ""}`}>
              <input
                type="text"
                placeholder="Buscar..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                autoFocus={openSearch}
              />

              {query && openSearch && (
                <div className="search-results">
                  {filteredResults.length > 0 ? (
                    filteredResults.map((item, index) => (
                      <div
                        key={index}
                        className="search-item"
                        onClick={() => {
                          navigate(item.path);
                          handleNavClick();
                        }}
                      >
                        {item.title}
                      </div>
                    ))
                  ) : (
                    <div className="search-item">Nenhum resultado</div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Botão Hamburger Mobile */}
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Abrir menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>
    </header>
  );
}